var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"encapsulate-wrapper shadow"},[(!_vm.value)?_c('strong',{staticClass:"text-red"},[_vm._v(_vm._s(_vm.textError))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }